import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import type { Partner } from '../../../types/partners';
import { Reveal } from '../../ui/Reveal';
import { TryPlatformButton } from '../TryPlatformButton';
import { UpvoteButton } from '../UpvoteButton';
import { PARTNER_BUTTON_CLASS } from './PartnerProfileHero';
export function PartnerFinalCta({
  partner
}: {
  partner: Partner;
}) {
  const {
    finalCta,
    relationshipNote
  } = partner.profile;
  return <section aria-labelledby="partner-final-heading" className="bg-surface" data-id="element-972" data-mp="3adbzp7d7nqyg">
      <Reveal className="mx-auto flex w-full max-w-[880px] flex-col items-center px-4 py-20 text-center sm:px-6 lg:py-24" data-id="element-973" data-mp="3ab8zxvm9ajgj">
        <h2 id="partner-final-heading" className="sf-display text-balance text-[32px] leading-[1.04] text-text-primary sm:text-[46px]" data-id="element-974" data-mp="3je0ei4afhvce">
          {finalCta.headline}
        </h2>
        <p className="mt-4 max-w-xl text-base leading-relaxed text-text-secondary" data-id="element-975" data-mp="2vltdgrtrd06n">{finalCta.body}</p>
        <div className="mt-8 flex w-full flex-col items-center gap-3 sm:w-auto sm:flex-row" data-id="element-976" data-mp="aq9tegsicu7g">
          <TryPlatformButton partner={partner} placement="profile_final" label={partner.tryLabel} size="xl" className={`w-full sm:w-auto ${PARTNER_BUTTON_CLASS}`} data-id="element-977" data-mp="aofhfrz7scfi" />
          <UpvoteButton partner={partner} placement="profile_final" variant="inline" data-id="element-978" data-mp="kgla73xaixvr" />
        </div>
        <p className="mt-10 max-w-2xl text-xs leading-relaxed text-text-tertiary" data-id="element-979" data-mp="pemsvnqt0v6p">{relationshipNote}</p>
        <Link to="/partners" className="mt-6 inline-flex min-h-[44px] items-center gap-1.5 text-sm font-semibold text-lime hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime" data-id="element-980" data-mp="3nycx43wkkrn3">
          <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-981" data-mp="5qx840habv6z" />
          Back to all partners
        </Link>
      </Reveal>
    </section>;
}